module.exports = __webpack_public_path__ + "static/media/img-leadshop.3e3b07c1.jpg";